




import Vue from 'vue';
import BulkAddUsersComplete from '@/components/bulk-add-users/bulk-add-users-complete.component.vue';
export default Vue.extend({
  components: {
    'bulk-add-users-complete': BulkAddUsersComplete
  }
});
